import { StyleSheet } from 'react-native';
import {
    PRIMARY_COLOR,
} from 'coooltv-js-shared/src/styles/common';
import { BLUE_COLOR, GREY_COLOR } from '../../styles/common';

const styles = StyleSheet.create({
    second_wrapper: {
        paddingBottom: 110,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        marginTop: -2,
        justifyContent: 'center',
    },
    second_wrapper_phone: {
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        display: 'flex',
        marginTop: -2,
        paddingBottom: 50,
        justifyContent: 'center',
    },
    login_label: {
        color: GREY_COLOR,
        alignSelf: 'center',
        fontSize: 24,
        marginLeft: -130,
        marginVertical: 45,
        paddingLeft: 90,
    },
    login_label_phone: {
        color: GREY_COLOR,
        alignSelf: 'center',
        fontSize: 18,
        marginHorizontal: 6,
        marginVertical: '15%',
    },
    image: {
        width: 120,
        height: 120,
    },
    login_container: {
        display: 'flex',
        flexDirection: 'row',
    },
    login_container_phone: {
        display: 'flex',
        flexDirection: 'column',
    },
    input_wrapper: {
        flex: 1,
    },
    image_wrapper: {
        height: '55%',
        marginRight: 45,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: PRIMARY_COLOR,
        borderRadius: '10px',
    },
    image_wrapper_phone: {
        height: '37%',
        alignSelf: 'center',
        marginBottom: '15%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: PRIMARY_COLOR,
        borderRadius: '10px',
    },
    third_wrapper: {
        minWidth: 490,
        alignSelf: 'center',
    },
    third_wrapper_phone: {
        alignSelf: 'center',
        width: '90%',
    },
    my_cooolbox_link: {
        color: BLUE_COLOR,
    },
    my_cooolbox_link_phone: {
        color: BLUE_COLOR,
    },
    messageWrapper: {
        paddingTop: 40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    message: {
        maxWidth: 820,
    },
    messageText: {
        color: GREY_COLOR,
        alignSelf: 'center',
        fontSize: 24,
        marginLeft: -130,
        marginVertical: 45,
        paddingLeft: 90,
    },
    messageLink: {
        color: BLUE_COLOR,
    },
    messageTextMobile: {
        color: GREY_COLOR,
        alignSelf: 'center',
        fontSize: 18,
        marginHorizontal: 6,
        marginVertical: 20,
    },
});

export default styles;
